import { NextPage } from 'next';
import React from 'react';
import Main from '@components/Layout/Main';
import FAQs from '@components/FAQs';
import useLoadingReset from '@hooks/useLoadingReset';
import useMyAccountRedirect from '@hooks/useMyAccountRedirect';
import useScrollPosition from '@hooks/useScrollToPositionOnMount';

import { CarJourneyType } from '../services';

import { simpleRedirectionGetInitialProps } from '@utils/getInitialProps/common';
import HomePageOptions from '@components/HomePageOptions';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../context/featureSwitchApp';

const FrontPage: NextPage = () => {
    useLoadingReset();
    useMyAccountRedirect();
    useScrollPosition();

    const isStockAvailable = useFeatureSwitchEnabled(
        FEATURES_LIST.FEATURE_SWITCH_ALLOWED_CAR_JOURNEYS,
        CarJourneyType.STOCK
    );

    const isConfigurableAvailable = useFeatureSwitchEnabled(
        FEATURES_LIST.FEATURE_SWITCH_ALLOWED_CAR_JOURNEYS,
        CarJourneyType.CONFIGURABLE
    );

    return (
        <Main>
            <HomePageOptions isStockAvailable={isStockAvailable} isConfigurableAvailable={isConfigurableAvailable} />
            <FAQs />
        </Main>
    );
};

FrontPage.getInitialProps = simpleRedirectionGetInitialProps;

export default FrontPage;
